<template>
    <div
        class="details-info"
        :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'"
    >
        <div v-if="!is304">
            <div class="vanEmpty" v-if="apiLoading">
                <div>
                    <van-empty
                        description="数据加载中..."
                        :image="require('@/assets/image/notData.png')"
                    />
                </div>
            </div>
            <div class="header-bg" v-else>
                <van-sticky z-index="100">
                    <div
                        ref="contentNavBarRef"
                        class="content-nav-bar"
                        :class="
                            bodyOffsetTop <= contentNavBarHeight && hcbyid === 200
                                ? 'sticky-header'
                                : ''
                        "
                        :style="`backdrop-filter: blur(${filterNum}px)`"
                    >
                        <van-nav-bar title="量化交易策略回测详情">
                            <template #left>
                                <van-icon
                                    :name="shareType === 'true' ? 'cross' : 'arrow-left'"
                                    size="18"
                                    @click="goBack"
                                />
                            </template>
                            <template #right>
                                <img
                                    v-if="isHc && compareVersions($route.query.version, 9.68)"
                                    :src="$route.query.themeStyleVs == 2 ? blackShare : shareImg"
                                    @click="shareBtnFn"
                                    alt=""
                                />
                            </template>
                        </van-nav-bar>
                    </div>
                </van-sticky>
                <div class="details-content" v-if="hcbyid === 200">
                    <div class="header">
                        <div class="title">
                            <p class="name">量化交易回测</p>

                            <div class="title_right" v-if="isHc">
                                <button
                                    class="title-right_edit vip-parent"
                                    v-if="!Obj.apiData.condition.mn_status"
                                    @click="handleClickCreateBtn"
                                >
                                    编辑 <i class="vip-icon" v-show="!isVip && vipIcon"></i>
                                </button>
                                <button
                                    class="moniBtn"
                                    v-if="Obj.apiData.condition.mn_status"
                                    @click="goMnDetail"
                                >
                                    前往模拟盘
                                </button>
                                <button
                                    class="moniBtn vip-parent"
                                    @click="handleBtmMnjy"
                                    v-if="
                                        Obj.apiData.condition.type_info != 2 &&
                                        !Obj.apiData.condition.mn_status
                                    "
                                >
                                    开启模拟交易 <i class="vip-icon" v-show="!isVip && vipIcon"></i>
                                </button>
                            </div>
                        </div>
                        <p class="proceed" v-if="Obj.apiData.condition.mn_status">· 模拟盘进行中</p>
                    </div>

                    <div class="collapse" v-if="isHc">
                        <FactorDetailModal
                            :collection_condition="collection_condition"
                        ></FactorDetailModal>
                        <!-- <p class="title" @click="handleClickShowAll">
              · 因子池内容
              <span v-if="checkedYzList.length > 2">
                <van-icon name="arrow-down" v-if="num === 2" />
                <van-icon name="arrow-up" v-else />
              </span>
            </p>
            <div class="yz-list">
              <van-row gutter="8">
                <template v-for="(item, index) in checkedYzList">
                  <van-col
                    span="12"
                    :key="index"
                    v-if="index < num"
                    :class="'showParameterAll_animation'"
                    @click="gotoFactorDetail(item)"
                  >
                    <p class="li">{{ item.FactorName }}</p>
                  </van-col>
                </template>
              </van-row>
            </div> -->
                    </div>

                    <div class="collapse" v-if="isHc">
                        <p class="title" @click="handleClickShowParameterAll">
                            · 交易参数
                            <span>
                                <van-icon name="arrow-down" v-if="isShowParameterAll == false" />
                                <van-icon name="arrow-up" v-else />
                            </span>
                        </p>
                        <div class="yz-list parameter">
                            <van-row gutter="8">
                                <van-col span="24" class="showParameterAll_animation">
                                    <div class="li">
                                        <p class="par-classify">基础 I</p>

                                        <ul class="par-ul">
                                            <li class="par-ul_li">
                                                <p class="par-ul_label">初始化资金</p>

                                                <p class="par-ul_content">
                                                    {{ Obj.startMoney || '--' }}元
                                                </p>
                                            </li>

                                            <li class="par-ul_li">
                                                <p class="par-ul_label">持股上限</p>

                                                <p class="par-ul_content">
                                                    {{ Obj.PositionLimit || '--' }}只
                                                </p>
                                            </li>
                                            <li class="par-ul_li">
                                                <p class="par-ul_label">持股周期</p>

                                                <p class="par-ul_content">
                                                    <span
                                                        v-for="(
                                                            item, index
                                                        ) in Obj.holdPeriodList.split(',')"
                                                        :key="index"
                                                        >{{ item }}天</span
                                                    >
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </van-col>

                                <van-col
                                    span="24"
                                    v-show="isShowParameterAll"
                                    :class="isShowParameterAll ? 'showParameterAll_animation' : ''"
                                >
                                    <div class="li">
                                        <p class="par-classify">买入 I</p>

                                        <ul class="par-ul">
                                            <li class="par-ul_li">
                                                <p class="par-ul_label">买入时机</p>

                                                <p class="par-ul_content">次日开盘买入</p>
                                            </li>

                                            <li class="par-ul_li">
                                                <p class="par-ul_label">单日买入</p>

                                                <p class="par-ul_content">
                                                    {{ Obj.buyLimit || '--' }}只
                                                </p>
                                            </li>

                                            <li class="par-ul_li">
                                                <p class="par-ul_label">买入顺序</p>

                                                <p class="par-ul_content">
                                                    <span v-if="Obj.sortKind == 0">成交额</span>
                                                    <span v-if="Obj.sortKind == 1">涨跌幅</span>
                                                    <span v-if="Obj.sortKind == 2">换手率</span>
                                                    <span v-if="Obj.sortKind == 3">量比</span>
                                                    <span v-if="Obj.sortKind == 4">总市值</span>
                                                    <span v-if="Obj.sortKind == 5">流通市值</span>
                                                    <span v-if="Obj.sortKind == 6">市盈率TTM</span>
                                                    <span v-if="Obj.sortKind == 7">振幅</span>
                                                    <span v-if="Obj.sortDirection == 0"
                                                        >从大到小</span
                                                    >
                                                    <span v-if="Obj.sortDirection == 1"
                                                        >从小到大</span
                                                    >
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </van-col>
                                <div v-if="condition.TradeRule == '0'">
                                    <van-col
                                        span="24"
                                        v-show="isShowParameterAll"
                                        :class="
                                            isShowParameterAll ? 'showParameterAll_animation' : ''
                                        "
                                    >
                                        <div class="li">
                                            <p class="par-classify">风控 I</p>

                                            <ul class="par-ul">
                                                <li class="par-ul_li">
                                                    <p class="par-ul_label">仓位</p>

                                                    <p class="par-ul_content">满仓</p>
                                                </li>

                                                <li class="par-ul_li">
                                                    <p class="par-ul_label">止盈</p>

                                                    <p class="par-ul_content">
                                                        收益率 ≥
                                                        {{
                                                            (Obj.stopProfitHigh * 100).toFixed(2) ||
                                                            '--'
                                                        }}% 时回落{{
                                                            (Obj.stopProfitLow * 100).toFixed(2) ||
                                                            '--'
                                                        }}%
                                                    </p>
                                                </li>

                                                <li class="par-ul_li">
                                                    <p class="par-ul_label">止损</p>

                                                    <p class="par-ul_content">
                                                        收益率 ≤
                                                        {{
                                                            (Obj.stopLoss * 100).toFixed(2) || '--'
                                                        }}%
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                        <!-- 标签 -->
                                        <span class="tag-info">普通规则交易</span>
                                    </van-col>
                                </div>
                                <div v-else>
                                    <van-col
                                        span="24"
                                        v-show="isShowParameterAll"
                                        :class="
                                            isShowParameterAll ? 'showParameterAll_animation' : ''
                                        "
                                    >
                                        <div class="li-list">
                                            <p class="par-classify">风控 I</p>
                                            <div class="sc-list">
                                                <p class="tag-title-text">强势<br />市场</p>
                                                <ul class="par-ul">
                                                    <li class="par-ul_li">
                                                        <p class="par-ul_label">仓位</p>

                                                        <p class="par-ul_content">
                                                            {{
                                                                (
                                                                    condition.MightyRiskPosition *
                                                                    100
                                                                ).toFixed(2) || '--'
                                                            }}%
                                                        </p>
                                                    </li>

                                                    <li class="par-ul_li">
                                                        <p class="par-ul_label">止盈</p>

                                                        <p class="par-ul_content">
                                                            收益率 ≥
                                                            {{
                                                                (
                                                                    condition.MightyStopProfitHigh *
                                                                    100
                                                                ).toFixed(2) || '--'
                                                            }}% 时回落{{
                                                                (
                                                                    condition.MightyStopProfitLow *
                                                                    100
                                                                ).toFixed(2) || '--'
                                                            }}%
                                                        </p>
                                                    </li>

                                                    <li class="par-ul_li">
                                                        <p class="par-ul_label">止损</p>

                                                        <p class="par-ul_content">
                                                            收益率 ≤
                                                            {{
                                                                (
                                                                    condition.MightyStopLoss * 100
                                                                ).toFixed(2) || '--'
                                                            }}%
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="sc-list">
                                                <p class="tag-title-text">弱势<br />市场</p>

                                                <ul class="par-ul">
                                                    <li class="par-ul_li">
                                                        <p class="par-ul_label">仓位</p>

                                                        <p class="par-ul_content">
                                                            {{
                                                                (
                                                                    condition.WeaknessRiskPosition *
                                                                    100
                                                                ).toFixed(2) || '--'
                                                            }}%
                                                        </p>
                                                    </li>

                                                    <li class="par-ul_li">
                                                        <p class="par-ul_label">止盈</p>

                                                        <p class="par-ul_content">
                                                            收益率 ≥
                                                            {{
                                                                (
                                                                    condition.WeaknessStopProfitHigh *
                                                                    100
                                                                ).toFixed(2) || '--'
                                                            }}% 时回落{{
                                                                (
                                                                    condition.WeaknessStopProfitLow *
                                                                    100
                                                                ).toFixed(2) || '--'
                                                            }}%
                                                        </p>
                                                    </li>

                                                    <li class="par-ul_li">
                                                        <p class="par-ul_label">止损</p>

                                                        <p class="par-ul_content">
                                                            收益率 ≤
                                                            {{
                                                                (
                                                                    condition.WeaknessStopLoss * 100
                                                                ).toFixed(2) || '--'
                                                            }}%
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="sc-list">
                                                <p class="tag-title-text">震荡<br />市场</p>

                                                <ul class="par-ul">
                                                    <li class="par-ul_li">
                                                        <p class="par-ul_label">仓位</p>

                                                        <p class="par-ul_content">
                                                            {{
                                                                (
                                                                    condition.VibrateRiskPosition *
                                                                    100
                                                                ).toFixed(2) || '--'
                                                            }}%
                                                        </p>
                                                    </li>

                                                    <li class="par-ul_li">
                                                        <p class="par-ul_label">止盈</p>

                                                        <p class="par-ul_content">
                                                            收益率 ≥
                                                            {{
                                                                (
                                                                    condition.VibrateStopProfitHigh *
                                                                    100
                                                                ).toFixed(2) || '--'
                                                            }}% 时回落{{
                                                                (
                                                                    condition.VibrateStopProfitLow *
                                                                    100
                                                                ).toFixed(2) || '--'
                                                            }}%
                                                        </p>
                                                    </li>

                                                    <li class="par-ul_li">
                                                        <p class="par-ul_label">止损</p>

                                                        <p class="par-ul_content">
                                                            收益率 ≤
                                                            {{
                                                                (
                                                                    condition.VibrateStopLoss * 100
                                                                ).toFixed(2) || '--'
                                                            }}%
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <!-- 标签 -->
                                        <span class="tag-info" @click="viewIntroduction = true"
                                            >大盘择时交易-{{
                                                isTemplateInfo(condition.RiskTemplate)
                                            }}
                                            <img
                                                class="tag-info-img"
                                                src="../../assets/image/help.png"
                                                alt=""
                                        /></span>
                                    </van-col>
                                </div>
                            </van-row>
                        </div>
                    </div>

                    <div class="btm-style" ref="body">
                        <div ref="tabs" class="tabs">
                            <van-sticky :offset-top="contentNavBarHeight - 2" z-index="99">
                                <van-tabs v-model="active" @change="handleClickTabs">
                                    <van-tab title="评级报告"></van-tab>
                                    <van-tab title="最新信号"></van-tab>
                                    <van-tab title="历史累计收益"></van-tab>
                                    <van-tab title="回测分析"></van-tab>
                                </van-tabs>
                            </van-sticky>
                        </div>

                        <div id="section1" ref="section1">
                            <LhPjbg
                                :ReportGradeResult="Obj.apiData.ReportGradeResult"
                                :startDate="Obj.startDate"
                                :endDate="Obj.endDate"
                                :RadarMapResult="Obj.apiData.RadarMapResult"
                            ></LhPjbg>
                        </div>

                        <p
                            style="background: #f8f9fc; height: 8px"
                            :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
                        ></p>

                        <div id="section2" ref="section2">
                            <Zxxg
                                :tabsHeight="tabsHeight"
                                :headerHeight="contentNavBarHeight"
                                :StockPoolsResult="Obj.apiData.StockPoolsResult"
                            ></Zxxg>
                        </div>

                        <p
                            style="background: #f8f9fc; height: 8px"
                            :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
                        ></p>

                        <div id="section3" ref="section3">
                            <Ljsy
                                :tabsHeight="tabsHeight"
                                :headerHeight="contentNavBarHeight"
                                :Obj="Obj"
                                :checkedYzList="checkedYzList"
                            ></Ljsy>
                        </div>

                        <p
                            style="background: #f8f9fc; height: 8px"
                            :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
                        ></p>

                        <div id="section4" ref="section4">
                            <LhHcfx
                                :tabsHeight="tabsHeight"
                                :headerHeight="contentNavBarHeight"
                                :BacktestAnalysisResult="Obj.apiData.BacktestAnalysisResult"
                                :holdPeriodList="Obj.holdPeriodList"
                            ></LhHcfx>
                        </div>

                        <p
                            style="background: #f8f9fc; height: 8px"
                            :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
                        ></p>

                        <LhLsmx
                            :Obj="Obj"
                            :checkedYzList="checkedYzList"
                            :tabsHeight="tabsHeight"
                            :headerHeight="contentNavBarHeight"
                        ></LhLsmx>
                    </div>
                </div>

                <van-empty
                    :description="hcmesg"
                    :image="require('@/assets/image/notData.png')"
                    v-else
                />
            </div>

            <van-overlay :show="showoVerlay">
                <div class="wrapper-overlay" @click.stop>
                    <van-form @submit="saveMnjy">
                        <p class="wrapper-title">创建量化模拟交易</p>

                        <p class="wrapper-label">模拟交易名称</p>
                        <div class="name">
                            <van-field
                                v-model="mnjyName"
                                autosize
                                maxlength="10"
                                show-word-limit
                                placeholder="请输入模拟名称"
                                :rules="[{ required: true, message: '请输入模拟名称' }]"
                            />
                        </div>
                        <p class="wrapper-label">初始化资金</p>
                        <div class="c-l-right">
                            <van-field v-model="capital" type="digit" label="" />
                            <span class="unit">元</span>
                        </div>

                        <p class="wrapper-label">选定持仓周期</p>
                        <div class="c-l-right">
                            <p class="imitation-select" @click="showPeriod = true">
                                {{ periodValue }}
                                <van-icon name="arrow-down" class="arrow-down" />
                            </p>
                        </div>

                        <van-action-sheet v-model="showPeriod">
                            <van-picker
                                title="选定持仓周期"
                                show-toolbar
                                :columns="columnsPeriod"
                                @confirm="onConfirmPeriod"
                                @cancel="onCancelPeriod"
                                :default-index="cgzq_defaultIndex"
                            />
                        </van-action-sheet>

                        <div class="wrapper-btn">
                            <van-button
                                class="left"
                                @click="showoVerlay = false"
                                native-type="button"
                                >取消</van-button
                            >
                            <!-- getClientFun(); -->

                            <van-button
                                type="info"
                                class="right"
                                :loading="loadingMn"
                                loading-text="开启中..."
                                native-type="submit"
                                >开启模拟交易
                            </van-button>
                        </div>
                    </van-form>
                </div>
            </van-overlay>
        </div>

        <!-- 没有慧豆时页面显示 -->
        <NotHd v-else></NotHd>

        <takeOut
            :show="takeShow"
            :name="takeName"
            :btnText="takeBtnName"
            type="openMn"
            @cancelBasis="cancelBasis"
            @linkGo="linkGo"
        ></takeOut>
        <!-- vip弹窗 -->
        <vipInfo :show="vipShow"></vipInfo>

        <!-- 大盘风控模版介绍说明 -->
        <van-popup v-model="viewIntroduction" :style="{ width: '70%' }" round>
            <div class="dpfkmbsm">
                <p class="title">大盘风控模版说明</p>

                <ul class="mbsmDialog">
                    <div v-if="condition.RiskTemplate == 0">
                        <h2>MACD仓控模板</h2>
                        <li>
                            出现MACD&gt;0且MACD红柱没有出现持续萎缩则为强势市场；
                            <br />
                            出现MACD&lt;0且MACD绿柱暂未出现连续收缩则为弱势市场；
                            <br />
                            其余情况为震荡市场。
                        </li>
                    </div>

                    <div v-if="condition.RiskTemplate == 1">
                        <h2>均线模板</h2>
                        <li>
                            根据自适应线变化来考量市场强弱，当指数变动开始加速偏离时定义为强势，反之则为弱势，其余情况为震荡市
                        </li>
                    </div>

                    <div v-if="condition.RiskTemplate == 2">
                        <h2>成交额仓控模板</h2>
                        <li>
                            大盘成交量变化快线大于慢线时为强势市场；
                            <br />
                            大盘成交量变化快线小于慢线时为弱势市场；
                            <br />
                            其余为震荡市场
                        </li>
                    </div>

                    <div v-if="condition.RiskTemplate == 3">
                        <h2>乖离仓控模板</h2>
                        <li>
                            收盘价正向偏离均线较大时是强势市场；
                            <br />
                            收盘价负向偏离均线较大时为弱势市场；
                            <br />
                            其余情况为震荡市场。
                        </li>
                    </div>

                    <div v-if="condition.RiskTemplate == 4">
                        <h2>价格仓控模板</h2>
                        <li>
                            K线整体连续4天上移为强势市场；
                            <br />
                            K线整体连续4天下降为弱势市场；
                            <br />
                            其余为震荡市场。
                        </li>
                    </div>

                    <div v-if="condition.RiskTemplate == 5">
                        <h2>价格均线仓控模板</h2>
                        <li>
                            收盘价站上5日线且5日平均线大于昨日为强势市场；
                            <br />
                            收盘价跌破5日线且5日平均线小于昨日为弱势市场；
                            <br />
                            其余为震荡市场。
                        </li>
                    </div>
                </ul>
            </div>
            <div class="gotit">
                <van-button type="info" @click="viewIntroduction = false">知道了</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { factorArrCheckoutFun } from '@/utils/commonAPI';
import mixin from '@/mixins/index.js';
import LhPjbg from '@/components/details/LhPjbg.vue';
import Zxxg from '@/components/details/Zxxg.vue';
import Ljsy from '@/components/details/Ljsy.vue';
import LhHcfx from '@/components/details/LhHcfx.vue';
import LhLsmx from '@/components/details/LhLsmx.vue';
import NotHd from '@/components/notHd/notHd.vue';
import { getFactorHq, getLhjyHCById, mockpanelOpen } from '@/api/create';
import VueScrollTo from 'vue-scrollto';
import { mapMutations } from 'vuex';
import { getClientRedis, setShareById } from '@/api/index.js';
import vipInfo from '@/components/diaLog/vipInfo.vue';
import { compareVersions,parseCollectionCondition } from '@/utils/format.js';
export default {
    name: 'Lhhc-details',
    mixins: [mixin],
    data() {
        return {
            shareImg: require('../../assets/image/share_btn.png'),
            blackShare: require('../../assets/image/blockImg/share_img.png'),
            contentNavBarHeight: 93,
            is304: false,
            apiLoading: true,
            showoVerlay: false,
            hcbyid: 200,
            hcmesg: '',
            capital: 100000, //初始化资金
            bodyOffsetTop: 0,
            isShowParameterAll: false,
            index_info: 1,
            num: 2,
            active: 0,
            ReportGradeResult: {},
            starDate: '',
            endDate: '',
            BacktestAnalysisResult: [],
            periodArr: [],
            condition: {},
            loadingHc: false,
            loadingMn: false,
            isShowSaveHc: true,
            filterNum: 0,
            tabsHeight: 0,
            mnjyName: '',
            clDetails: '',
            section1: 0,
            section1_initialize: 0,
            columnsPeriod: [],
            showPeriod: false,
            periodValue: '',
            MaxRetreatRateIndex: 0,
            cgzq_defaultIndex: 0, //持股周期select默认值
            h_id: null,
            timeoutId: null, // 添加 timeoutId 属性，用于存储 setTimeout 的返回值
            f_id_arr: '',
            takeShow: false,
            takeName: '',
            takeBtnName: '',
            isShowKd: false,
            isHc: false,
            shareType: 'false',
            // 弹窗模版数据
            infoDialogObj: {},
            // VIP标志
            isVip: false,
            vipShow: false,
            vipIcon: false,
            viewIntroduction: false,
            collection_condition: {}
        };
    },
    components: {
        LhPjbg,
        Zxxg,
        Ljsy,
        LhHcfx,
        LhLsmx,
        NotHd,
        vipInfo
    },
    filters: {},
    //计算属性
    computed: {
        checkedYzList: function () {
            return this.$store.state.checkedYzList; // 获取全局状态
        },
        Obj: function () {
            this.$store.state.Obj.holdPeriodList = this.$store.state.Obj.holdPeriodList + '';
            return this.$store.state.Obj; // 获取全局状态
        },
        contentNavBar: function () {
            return this.$store.state.contentNavBar; // 获取全局状态
        },
        publicHcID: function () {
            return this.$store.state.publicHcID; // 获取vuex的id 要是存在id走编辑逻辑
        },
        btnDisabled: function () {
            return this.$store.state.btnDisabled; // 用来控制回测是变灰还是现实更新
        }
    },
    watch: {
        '$store.state.isVip': {
            handler(newValue) {
                this.isVip = newValue;
            },
            immediate: true // 立即执行一次
        }
    },
    created() {
        this.shareType = this.getUrlQuery('shareType');
        // this.getClientFun();
        this.$nextTick(function () {
            if (compareVersions(this.$route.query.version, 9.71)) {
                this.vipIcon = true;
            } else {
                this.vipIcon = false;
            }
        });
    },
    async mounted() {
        await this.getLhjyHCByIdFun();

        var navHeight = this.$refs.contentNavBarRef.offsetHeight;
        this.contentNavBarHeight = navHeight;

        this.mnjyName = this.Obj.name || '';
        this.clDetails = this.Obj.desc || '';
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('scroll', this.handleScrollTab);

        //获取评级报告和回测分析的高度
        var contentTabs = this.$refs['tabs'];
        this.tabsHeight = contentTabs.offsetHeight;

        this.bodyOffsetTop = this.$refs.body.getBoundingClientRect().top;
        this.section1_initialize = this.$refs.section1.getBoundingClientRect().top;
        var day = this.Obj.holdPeriodList.split(',');
        this.columnsPeriod = day.map((number) => number + '天');
        var indices = this.getMaxIndices(this.Obj.apiData.BacktestAnalysisResult, 'YearRate');
        this.MaxRetreatRateIndex = indices.MaxRetreatRateIndex;
        this.periodValue = this.columnsPeriod[this.MaxRetreatRateIndex];
        this.capital = this.Obj.startMoney || 100000;
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('scroll', this.handleScrollTab);
    },
    methods: {
        compareVersions,
        ...mapMutations(['resetState']),

        //查询是否显示扣豆
        getClientFun() {
            var _this = this;
            getClientRedis({})
                .then((res) => {
                    if (res.err === 200) {
                        var data = JSON.parse(res.data);
                        _this.setLocalData(data);
                        if (data.openMn === 'true') {
                            _this.isShowKd = false;
                        } else {
                            _this.isShowKd = true;
                        }
                    } else {
                        _this.isShowKd = true;
                        _this.setLocalData();
                    }
                })
                .catch(() => {
                    _this.isShowKd = true;
                    _this.setLocalData();
                });
        },

        //根据h_id查询信息
        getLhjyHCByIdFun: function (type) {
            var _this = this;
            return getLhjyHCById({
                h_id: this.$route.query.h_id
            })
                .then((res) => {
                    _this.loadingHc = false;
                    _this.hcbyid = res.err;
                    _this.hcmesg = res.msg;
                    _this.apiLoading = false;

                    if (res.err === 200) {
                        _this.isHc = res.data.condition.isHc;
                        _this.condition = res.data.condition;

                        var vuexObj = {};
                        if (res.data.condition.TradeRule == 0) {
                            vuexObj = {
                                holdPeriodList: res.data.condition.chigu_cycle,
                                apiData: res.data,
                                startDate: res.data.condition.starDate,
                                endDate: res.data.condition.endDate,
                                isCustomSelected: res.data.condition.chigu_type == 1 ? true : false,
                                startMoney: res.data.condition.startMoney,
                                PositionLimit: res.data.condition.posLimit,
                                buyLimit: res.data.condition.buyLimit,
                                sortKind: res.data.condition.sortKind,
                                sortDirection: res.data.condition.sortDirection,
                                stopProfitHigh: res.data.condition.stopProfitHigh,
                                stopProfitLow: res.data.condition.stopProfitLow,
                                stopLoss: res.data.condition.stopLoss,
                                buyType: res.data.condition.buyType,
                                type_info: res.data.condition.type_info, //因子类型 1A股 2etf
                                isEdit: true,

                                TradeRule: 0
                            };
                        } else if (res.data.condition.TradeRule == 1) {
                            vuexObj = {
                                holdPeriodList: res.data.condition.chigu_cycle,
                                apiData: res.data,
                                startDate: res.data.condition.starDate,
                                endDate: res.data.condition.endDate,
                                isCustomSelected: res.data.condition.chigu_type == 1 ? true : false,
                                startMoney: res.data.condition.startMoney,
                                PositionLimit: res.data.condition.posLimit,
                                buyLimit: res.data.condition.buyLimit,
                                sortKind: res.data.condition.sortKind,
                                sortDirection: res.data.condition.sortDirection,
                                stopProfitHigh: res.data.condition.stopProfitHigh,
                                stopProfitLow: res.data.condition.stopProfitLow,
                                stopLoss: res.data.condition.stopLoss,
                                buyType: res.data.condition.buyType,
                                type_info: res.data.condition.type_info, //因子类型 1A股 2etf
                                isEdit: true,

                                TradeRule: 1,
                                RiskTemplate: res.data.condition.RiskTemplate, //  Int   风控模板 目前有6种，<br/>分别是 0:MACD仓控模板 1:均线模板<br/>2:成交额仓控模板 3:乖离仓控模板<br/>4:价格仓控模板 5:价格均线仓控模板

                                MightyRiskPosition: res.data.condition.MightyRiskPosition, //float 强势风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                                MightyStopProfitHigh: res.data.condition.MightyStopProfitHigh, //float 强势止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                                MightyStopProfitLow: res.data.condition.MightyStopProfitLow, //float 强势止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                                MightyStopLoss: res.data.condition.MightyStopLoss, //float 强势止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)

                                WeaknessRiskPosition: res.data.condition.WeaknessRiskPosition, //float 弱势风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                                WeaknessStopProfitHigh: res.data.condition.WeaknessStopProfitHigh, //float 弱势止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                                WeaknessStopProfitLow: res.data.condition.WeaknessStopProfitLow, //float 弱势止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                                WeaknessStopLoss: res.data.condition.WeaknessStopLoss, //float 弱势止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)

                                VibrateRiskPosition: res.data.condition.VibrateRiskPosition, //float 震荡风控仓位 eg:0.2就是20%--(TradeRule为1时传输)
                                VibrateStopProfitHigh: res.data.condition.VibrateStopProfitHigh, //float 震荡止盈卖出高水位线 eg:0.07就是7%--(TradeRule为1时传输)
                                VibrateStopProfitLow: res.data.condition.VibrateStopProfitLow, //float 震荡止盈卖出低水位线(止盈回撤线) eg:0.01就是1%--(TradeRule为1时传输)
                                VibrateStopLoss: res.data.condition.VibrateStopLoss //float 震荡止损卖出水位线 eg:-0.05就是-5%--(TradeRule为1时传输)
                            };
                        }

                        _this.$store.commit('setObj', vuexObj);

                        _this.$store.commit('setPublicHcID', res.data.condition.h_id);
                        _this.f_id_arr = res.data.condition.f_id_arr;

                        // 赋值因子组合
                        _this.collection_condition = JSON.parse(
                            res.data.condition.collection_condition
                        );

                        // if (
                        //   res.data.condition.collection_condition &&
                        //   res.data.condition.collection_condition != 'null' &&
                        //   res.data.condition.collection_type != 4
                        // ) {
                        //   var jsonData = JSON.parse(res.data.condition.collection_condition);

                        //   // 提取 "yzList" 和 "children" 下的每一项
                        //   var yzListItems = jsonData.yzList;
                        //   var childrenItems = [];

                        //   // 提取 "children" 中的每个子数组中的子项
                        //   if (jsonData.children) {
                        //     jsonData.children.forEach(function (childArray) {
                        //       childrenItems = childrenItems.concat(childArray);
                        //     });
                        //   }

                        //   // 合并 "yzList" 和 "children" 中的所有项到一个新数组
                        //   var combinedArray = yzListItems.concat(childrenItems);

                        //   this.$store.commit('setCheckedYzList', combinedArray);
                        // } else {
                        //   let a = res.data.condition.f_name_arr.split(',');
                        //   let b = [];
                        //   a.forEach((i, index) => {
                        //     b[index] = {
                        //       FactorName: i
                        //     };
                        //   });

                        //   if (res.data.condition.collection_type == 4) {
                        //     this.$store.commit('setCheckedYzList', b);
                        //   } else {
                        //     _this.getFactorHqFun(res.data.condition.f_id_arr);
                        //   }
                        // }
                        // 上报神策
                        this.reportShence();
                    } else if (res.err === 304) {
                        _this.is304 = true;
                        window.location.href = window.config.hdTips;
                    }
                })
                .catch((err) => {
                    _this.apiLoading = false;
                });
        },

        //行情
        getFactorHqFun: function (yzIds) {
            var params = {
                type: 'yz',
                factorID: yzIds,
                field: 'Desc,KanDian,FactorCode,XiFenZhongLei'
            };
            return getFactorHq(params)
                .then((res) => {
                    this.$store.commit('setCheckedYzList', res.data);
                })
                .catch((err) => {
                    this.$toast(err);
                });
        },

        //获取最大值YearRate年化收益
        getMaxIndices: function (data, maxYearRateKey) {
            var MaxRetreatRateIndex = 0;
            var MaxRetreatRate = data[0][maxYearRateKey];

            for (var i = 1; i < data.length; i++) {
                if (data[i][maxYearRateKey] > MaxRetreatRate) {
                    MaxRetreatRate = data[i][maxYearRateKey];
                    MaxRetreatRateIndex = i;
                }
            }

            return {
                MaxRetreatRateIndex
            };
        },
        //监听ref=body的滚滚动条距离用来控制header的背景色显示隐藏
        handleScroll() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            this.bodyOffsetTop = this.$refs.body.getBoundingClientRect().top;
            this.section1 = this.$refs.section1.getBoundingClientRect().top;
            this.filterNum = (scrollTop / (this.bodyOffsetTop / 2)).toFixed(2);
        },

        handleScrollTab() {
            if (
                this.$refs.section1.getBoundingClientRect().top <=
                this.tabsHeight + this.contentNavBar
            ) {
                this.active = 0;
            }
            if (
                this.$refs.section2.getBoundingClientRect().top <=
                this.tabsHeight + this.contentNavBar
            ) {
                this.active = 1;
            }
            if (
                this.$refs.section3.getBoundingClientRect().top <=
                this.tabsHeight + this.contentNavBar
            ) {
                this.active = 2;
            }
            if (
                this.$refs.section4.getBoundingClientRect().top <=
                this.tabsHeight + this.contentNavBar
            ) {
                this.active = 3;
            }
        },

        scrollToSection(sectionId) {
            VueScrollTo.scrollTo(`#${sectionId}`, 500, {
                offset: -120 // 调整偏移量以适应您的布局
            });
        },

        //手动点击切换的时候清除监听 然后1s之后再次恢复防止滚动和手动点击冲突
        handleClickTabs: function (i) {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            } else {
                window.removeEventListener('scroll', this.handleScrollTab);
            }

            if (i === 0) {
                this.scrollToSection('section1');
            } else if (i === 1) {
                this.scrollToSection('section2');
            } else if (i === 2) {
                this.scrollToSection('section3');
            } else if (i === 3) {
                this.scrollToSection('section4');
            }

            this.timeoutId = setTimeout(() => {
                window.addEventListener('scroll', this.handleScrollTab);
                this.timeoutId = null;
            }, 1500);
        },
        //把里面所有的FactorName放在一个数组里面
        extractFactorNames: function (data) {
            var factorNames = [];

            function recursiveExtract(obj) {
                if (obj && typeof obj === 'object') {
                    if (obj.hasOwnProperty('FactorName')) {
                        factorNames.push(obj.FactorName);
                    }

                    for (var key in obj) {
                        if (Array.isArray(obj[key])) {
                            obj[key].forEach((item) => recursiveExtract(item));
                        } else if (typeof obj[key] === 'object') {
                            recursiveExtract(obj[key]);
                        }
                    }
                }
            }

            recursiveExtract(data);

            return factorNames;
        },

        handleClickShowAll: function () {
            if (this.num === 2) {
                this.num = this.checkedYzList.length;
            } else {
                this.num = 2;
            }
        },

        //展示全部/一条交易参数
        handleClickShowParameterAll: function () {
            this.isShowParameterAll = !this.isShowParameterAll;
        },

        //获取id和name
        extractIdAndFactorName: function (data) {
            var ids = [];
            var factorNames = [];

            data.forEach((item) => {
                ids.push(item.ID);
                factorNames.push(item.FactorName);
            });

            return {
                ids,
                factorNames
            };
        },
        filterData: function (data) {
            var filteredData = [];
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                var filteredItem = {};
                filteredItem.ID = item.ID;
                filteredItem.FactorName = item.FactorName;
                filteredItem.RiZhangFu = item.RiZhangFu;
                filteredItem.XinHaoShuLiang = item.XinHaoShuLiang;
                filteredItem.yzType = item.yzType;
                filteredData.push(filteredItem);
            }
            return filteredData;
        },

        findIndexFromList: function (value, list) {
            const valueString = value + '天';
            for (var i = 0; i < list.length; i++) {
                if (list[i] === valueString) {
                    return i;
                }
            }

            return 0; // 如果未找到匹配值，则返回 0 表示未找到
        },

        //持仓周期
        onConfirmPeriod: function (value, index) {
            this.showPeriod = false;
            this.periodValue = value;
        },

        onCancelPeriod: function (picker, value, index) {
            this.showPeriod = false;
        },

        // 跳转模拟详情
        goMnDetail: function (item) {
            this.$router.push({
                path: '/mnDetail',
                name: 'mnDetail',
                query: {
                    token: this.$route.query.token || '',
                    zj_id: this.Obj.apiData.condition.zj_id,
                    sourceType: true,
                    themeStyleVs: this.$route.query.themeStyleVs || 0,
                    version: this.$route.query.version || ''
                }
            });
        },

        handleBtmMnjy: function () {
            // 判断是否是VIP
            if (this.isVip == false && compareVersions(this.$route.query.version, 9.92)) {
                let appJson = {
                    DialogType: 'basic'
                };
                DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
                    'factorTYPerDialog',
                    JSON.stringify(appJson),
                    ''
                );
                return false;
            } else if (this.isVip == false && compareVersions(this.$route.query.version, 9.71)) {
                // 如果不是VIP用户,弹出VIP提示
                //  this.vipShow = true;
                // 调用客户端js 弹窗
                // 开启模拟交易-JSON
                let appJson = {
                    channel: 'yinzi',
                    dzhadid: '0802',
                    sourcecode: '3509',
                    mediaID: '0802'
                };
                DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
                    'factorNoVipPerDialog',
                    JSON.stringify(appJson),
                    ''
                );
                return false;
            }

            let msg = [];
            factorArrCheckoutFun(this.f_id_arr).then((d) => {
                if (d.length > 0) {
                    d.forEach((i) => {
                        if (i.BacktestType == 2 || i.BacktestType == 3) {
                            msg.push(i.Name + '(不可回测)');
                        } else if (i.BacktestType == 10) {
                            msg.push(i.Name + '(已删除)');
                        }
                    });

                    this.$toast('开启模拟交易失败:' + msg.toString());
                } else {
                    // if (this.isShowKd) {
                    //   this.takeName = '每次开启模拟交易需消耗 2个慧豆';
                    //   this.takeBtnName = '继续开启';
                    //   this.takeShow = true;
                    //   return false;
                    // }

                    this.showoVerlay = true;
                    this.cgzq_defaultIndex = this.findIndexFromList(
                        this.periodValue.replace('天', ''),
                        this.columnsPeriod
                    );
                }
            });
        },

        findIndexFromList: function (value, list) {
            const valueString = value + '天';
            for (var i = 0; i < list.length; i++) {
                if (list[i] === valueString) {
                    return i;
                }
            }

            return 0; // 如果未找到匹配值，则返回 0 表示未找到
        },

        cancelBasis: function () {
            this.takeShow = false;
        },

        linkGo: function () {
            this.takeShow = false;
            this.showoVerlay = true;
        },

        //弹框点击开启模拟交易按钮
        saveMnjy: function () {
            if (this.capital < 100000 || this.capital === '') {
                this.$toast('初始化资金不能小于10万');
                return false;
            } else if (this.capital > 10000000) {
                this.$toast('初始化资金不能大于1000万');
                return false;
            } else if (this.capital.toString().startsWith('0')) {
                this.$toast('初始化资金输入格式不正确');
                return false;
            }

            this.mockpanelOpenFun();
        },

        //提交开启模拟交易
        mockpanelOpenFun: function () {
            var _this = this;
            _this.loadingMn = true;

            var params = {
                name: _this.mnjyName, //模拟盘名称
                cycle: _this.periodValue.replace('天', ''), // 选择的持股周期
                startMoney: _this.capital, //初始资金
                h_id: _this.h_id || _this.publicHcID //选中的回测ID
            };
            return mockpanelOpen(params)
                .then((res) => {
                    _this.loadingMn = false;
                    _this.$toast(res.msg);
                    if (res.err === 200) {
                        _this.showoVerlay = false;

                        let source = '';
                        if (_this.$route.query.source == 'appLhHc') {
                            source = 'appLhHc';
                        }
                        _this.$router.push({
                            path: '/mnDetail',
                            name: 'mnDetail',
                            query: {
                                token: _this.$route.query.token || '',
                                zj_id: res.data.zj_id,
                                themeStyleVs: _this.$route.query.themeStyleVs || 0,
                                version: _this.$route.query.version || '',
                                source: source // app开头的事客户端跳转过来的
                            }
                        });

                        setTimeout(() => {
                            _this.resetState(); //重置部分vuex
                        }, 500);
                    } else if (res.err === 304) {
                        window.location.href = window.config.hdTips;
                    } else if (res.err === 305) {
                        _this.$toast('功能使用异常，请检查您的登录状态');
                    }
                })
                .catch((err) => {
                    _this.loadingMn = false;
                    _this.$toast(err);
                });
        },

        //点击去编辑
        handleClickCreateBtn: function () {
            // 判断是否是VIP
            if (this.isVip == false && compareVersions(this.$route.query.version, 9.92)) {
                let appJson = {
                    DialogType: 'basic'
                };
                DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
                    'factorTYPerDialog',
                    JSON.stringify(appJson),
                    ''
                );
                return false;
            } else if (this.isVip == false && compareVersions(this.$route.query.version, 9.71)) {
                // 如果不是VIP用户,弹出VIP提示
                //  this.vipShow = true;
                // 调用客户端js 弹窗
                // 编辑量化策略-JSON
                let appJson = {
                    channel: 'yinzi',
                    dzhadid: '0801',
                    sourcecode: '3509',
                    mediaID: '0801'
                };
                DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
                    'factorNoVipPerDialog',
                    JSON.stringify(appJson),
                    ''
                );
                return false;
            }

            // 判断是否是大盘
            // if (this.condition.TradeRule == '1') {
            //   this.$dialog
            //     .alert({
            //       onfirmButtonText: '我知道了',
            //       message: '该回测含有大盘择时策略，请登录PC大智慧VIP客户端编辑'
            //     })
            //     .then(() => {
            //       // on close
            //     });

            //   return false;
            // }

            var ctype = JSON.parse(this.Obj.apiData.condition.collection_condition);

            var fIdArrToStr = parseCollectionCondition(ctype.yzList, ctype.children);

            let msg = [];
            factorArrCheckoutFun(fIdArrToStr).then((d) => {
                if (d.length > 0) {
                    d.forEach((i) => {
                        if (i.BacktestType == 2 || i.BacktestType == 3) {
                            msg.push(i.Name + '(不可回测)');
                        } else if (i.BacktestType == 10) {
                            msg.push(i.Name + '(已删除)');
                        }
                    });

                    this.$toast('编辑参数失败:' + msg.toString());
                } else {
                    let source = '';
                    if (this.$route.query.source == 'appLhHc' || !this.$route.query.source) {
                        source = 'appLhHc';
                    } else {
                        source = 'lhcl';
                    }

                    // 插入因子组合
                    this.$store.commit('setCheckedYzType', ctype.composeType);
                    this.$store.commit('setCheckedYzList', ctype.yzList);
                    this.$store.commit('setGroupYzList', ctype.children);

                    this.$router.push({
                        path: '/checkedYz',
                        name: 'CheckedYz',
                        query: {
                            source: source, //用来标注是从多因子还是量化过去的 app开头的事客户端跳转过来的
                            token: this.$route.query.token || '',
                            mySource: 'myLhHc', //用来标注是从个人中心过去的
                            themeStyleVs: this.$route.query.themeStyleVs || 0,
                            version: this.$route.query.version || '',
                            yzType: this.condition.type_info == 2 ? 'ETF' : 'A'
                        }
                    });
                }
            });
        },

        goBack: function () {
            if (this.shareType === 'true' || compareVersions(this.$route.query.version, 9.73)) {
                location.href = 'dzh_browser_url&goto=0&screen=263';
            } else {
                this.$router.go(-1);
            }
        },

        // 分享
        shareBtnFn: function () {
            let that = this;
            setShareById({}).then((res) => {
                if (res.err === 200) {
                    let obj = {
                        id: that.$route.query.h_id,
                        type: 4,
                        sid: res.data
                    };

                    let urlLink = encodeURIComponent(
                        window.config.shareLink +
                            '?DZHSPECIAL=256&sid=' +
                            res.data +
                            '&type=4&id=' +
                            that.$route.query.h_id
                    );
                    if (/android/i.test(navigator.userAgent)) {
                        urlLink = encodeURIComponent(urlLink);
                    }
                    window.location.href =
                        'dzh_browser_url&goto=0&screen=470&title=我在大智慧因子投研平台发现了一个量化交易策略回测，一起来看看吧！&text=因子投研平台&url=' +
                        urlLink +
                        '&icon=' +
                        window.config.shareLogo +
                        '&ext=' +
                        JSON.stringify(obj);
                }
            });
        },
        // 模版文字
        isTemplateInfo: function (num) {
            switch (num) {
                case '0':
                    return 'MACD仓控模板';
                    break;
                case '1':
                    return '均线模板';
                    break;
                case '2':
                    return '成交额仓控模板';
                    break;
                case '3':
                    return '乖离仓控模板';
                    break;
                case '4':
                    return '价格仓控模板';
                    break;
                case '5':
                    return '价格均线仓控模板';
                    break;
                default:
                    return '-';
                    break;
            }
        },
        // showDialogTemplate: function (num) {
        //   let infoObj = {
        //     name: '',
        //     desc: []
        //   };
        //   if (num == '0') {
        //     infoObj.name = 'MACD仓控模板';
        //     infoObj.desc[0] = '出现MACD>0且MACD红柱没有出现持续萎缩则为强势市场；';
        //     infoObj.desc[1] = '出现MACD<0且MACD绿柱暂未出现连续收缩则为弱势市场；';
        //     infoObj.desc[2] = '其余情况为震荡市场。';
        //   } else if (num == '1') {
        //     infoObj.name = '均线仓控模板';
        //     infoObj.desc[0] =
        //       '根据自适应线变化来考量市场强弱，当指数变动开始加速偏离时定义为强势，反之则为弱势，其余情况为震荡市。';
        //   } else if (num == '2') {
        //     infoObj.name = '成交额仓控模板';
        //     infoObj.desc[0] = '大盘成交量变化快线大于慢线时为强势市场；';
        //     infoObj.desc[1] = '大盘成交量变化快线小于慢线时为弱势市场；';
        //     infoObj.desc[2] = '其余为震荡市场。';
        //   } else if (num == '3') {
        //     infoObj.name = '乖离仓控模板';
        //     infoObj.desc[0] = '收盘价正向偏离均线较大时是强势市场；';
        //     infoObj.desc[1] = '收盘价负向偏离均线较大时为弱势市场；';
        //     infoObj.desc[2] = '其余情况为震荡市场。';
        //   } else if (num == '4') {
        //     infoObj.name = '价格仓控模板';
        //     infoObj.desc[0] = 'K线整体连续4天上移为强势市场；';
        //     infoObj.desc[1] = 'K线整体连续4天下降为弱势市场；';
        //     infoObj.desc[2] = '其余为震荡市场。';
        //   } else if (num == '5') {
        //     infoObj.name = '价格均线仓控模板';
        //     infoObj.desc[0] = '收盘价站上5日线且5日平均线大于昨日为强势市场；';
        //     infoObj.desc[1] = '收盘价跌破5日线且5日平均线小于昨日为弱势市场；';
        //     infoObj.desc[2] = '其余为震荡市场';
        //   }
        //   let messageInfo = '';
        //   infoObj.desc.forEach((item, index) => {
        //     messageInfo += item + '\n';
        //   });
        //   this.$dialog
        //     .alert({
        //       title: infoObj.name,
        //       onfirmButtonText: '我知道了',
        //       message: messageInfo
        //     })
        //     .then(() => {
        //       // on close
        //     });
        //   this.infoDialogObj = infoObj;
        // },
        // 上报神策
        reportShence: function () {
            if (
                this.condition.collection_condition &&
                this.condition.collection_condition != null
            ) {
                let jsonArray = JSON.parse(this.condition.collection_condition);
                // 判断 yzList 是否为空
                if (jsonArray.yzList.length > 0) {
                    jsonArray.yzList.forEach((element) => {
                        // 如果是普通因子就上报
                        if (element.yzType == 0) {
                            console.log('上报成功', {
                                factor_id: element.ID,
                                operate_type: 'back_test',
                                platform: 'Web-App'
                            });
                            sensors.track('factor_click', {
                                factor_id: element.ID,
                                operate_type: 'back_test',
                                platform: 'Web-App'
                            });
                        }
                    });
                }
                // 判断 children 是否为空
                if (jsonArray.children.length > 0) {
                    jsonArray.children.forEach((element) => {
                        element.forEach((element2) => {
                            console.log('上报成功', {
                                factor_id: element2.ID,
                                operate_type: 'back_test',
                                platform: 'Web-App'
                            });
                            sensors.track('factor_click', {
                                factor_id: element2.ID,
                                operate_type: 'back_test',
                                platform: 'Web-App'
                            });
                        });
                    });
                }
            }
        },
        // 点击因子跳转详情
        gotoFactorDetail: function (item) {
            if (item.yzType === 0) {
                // 正常的因子 走功能号
                window.location.href =
                    'dzh_browser_url&goto=0&screen=464&factorid=' +
                    item.ID +
                    '&factorname=' +
                    item.FactorName;
            } else if (item.yzType === 7) {
                location.href = '/mnDetail?DZHSPECIAL=4325641&zj_id=' + item.ID;
            } else {
                // 走因子详情
                location.href = '/zdyfactors?DZHSPECIAL=4325641&fid=' + item.ID;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.showParameterAll_animation {
    animation: flip-horizontal-top 0.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
}

@keyframes flip-horizontal-top {
    0% {
        transform: rotateX(180deg);
    }
    100% {
        transform: rotateX(360deg);
    }
}

.details-info {
    -webkit-overflow-scrolling: touch;
    .vanEmpty {
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .header-bg {
        height: 100vh;
        img {
            width: 24px;
            height: 24px;
        }
    }

    @keyframes fadeInOut {
        0% {
            opacity: 0.5;
        }
        50% {
            opacity: 0.8;
        }
        100% {
            opacity: 1;
        }
    }

    .header {
        padding: 20px 16px;
        .proceed {
            color: #11af7e;
            font-size: 12px;
            font-weight: 400;
            line-height: 14px;
            padding: 4px 6px;
            border-radius: 2px;
            background: #e2f7f2;
            display: inline-block;
            margin-top: 8px;
        }
        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .title_right {
                display: flex;
                align-items: center;
                .title-right_edit {
                    padding: 8px 16px;
                    border-radius: 4px;
                    border: 1px solid #286df7;
                    background: none;
                    color: #286df7;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 14px;
                    margin-right: 8px;
                }
                .moniBtn {
                    padding: 8px 16px;
                    border-radius: 4px;
                    background: #286df7;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 14px;
                    border: 1px solid #286df7;
                }
            }
            .name {
                font-weight: 500;
                font-size: 20px;
                color: #222;
            }
            .edit {
                width: 60px;
                height: 30px;
                background: #286df7;
                border-radius: 4px;
                font-weight: 500;
                font-size: 14px;
                color: #fff;
            }
        }
    }
    .collapse {
        padding: 0 16px 22px 16px;
        .title {
            font-weight: 700;
            font-size: 14px;
            color: #286df7;
        }
        .yz-list {
            .li {
                height: 34px;
                line-height: 34px;
                border: 1px solid #fff;
                border-radius: 4px;
                background: linear-gradient(to bottom right, #e6edff 10%, #fff 60%);
                padding: 0 12px;
                margin-top: 6px;
                font-weight: 500;
                font-size: 12px;
                color: rgba(55, 58, 77, 0.9);
                overflow: hidden; //超出的文本隐藏
                text-overflow: ellipsis; //溢出用省略号显示
                display: -webkit-box;
                -webkit-line-clamp: 1; // 超出多少行
                -webkit-box-orient: vertical;
            }
        }
        .parameter {
            .li {
                display: flex;
                height: auto;
                line-height: normal;
                padding: 10px 12px;
                .par-classify {
                    font-size: 14px;
                    font-weight: 700;
                    background: linear-gradient(
                        90deg,
                        rgba(35, 134, 234, 1),
                        rgba(67, 106, 206, 1)
                    );
                    -webkit-background-clip: text; /* Safari/Chrome */
                    -webkit-text-fill-color: transparent; /* Safari/Chrome */
                    background-clip: text; /* 其他浏览器 */
                    color: transparent;
                    margin-right: 26px;
                }

                .par-ul {
                    line-height: 20px;
                    .par-ul_li {
                        display: flex;
                        align-items: center;
                        .par-ul_label {
                            color: #666;
                            font-size: 12px;
                            font-weight: 400;
                            width: 80px;
                            flex-shrink: 0;
                        }
                        .par-ul_content {
                            color: rgba(55, 58, 77, 0.9);
                            font-size: 12px;
                            font-weight: bold;
                        }
                    }
                }
            }
            // 卖出列表
            .li-list {
                border: 1px solid red;
                padding: 10px 12px;
                border-radius: 4px;
                border: 1px solid #fff;
                background: linear-gradient(to bottom right, #e6edff 10%, #fff 60%);
                margin-top: 6px;
                font-weight: 500;
                font-size: 12px;
                color: rgba(55, 58, 77, 0.9);
                .par-classify {
                    font-size: 14px;
                    font-weight: 700;
                    background: linear-gradient(
                        90deg,
                        rgba(35, 134, 234, 1),
                        rgba(67, 106, 206, 1)
                    );
                    -webkit-background-clip: text; /* Safari/Chrome */
                    -webkit-text-fill-color: transparent; /* Safari/Chrome */
                    background-clip: text; /* 其他浏览器 */
                    color: transparent;
                    margin-right: 26px;
                }
                .sc-list {
                    border-radius: 6px;
                    background: #f7f7fc;
                    padding: 8px 12px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-content: center;
                    justify-content: flex-start;
                    margin-top: 8px;
                    .tag-title-text {
                        width: 60px;
                        font-size: 12px;
                        font-weight: 700;
                        background: linear-gradient(
                            90deg,
                            rgba(35, 134, 234, 1),
                            rgba(67, 106, 206, 1)
                        );
                        -webkit-background-clip: text; /* Safari/Chrome */
                        -webkit-text-fill-color: transparent; /* Safari/Chrome */
                        background-clip: text; /* 其他浏览器 */
                        color: transparent;
                    }
                    .par-ul {
                        line-height: 20px;
                        .par-ul_li {
                            display: flex;
                            // align-items: center;
                            .par-ul_label {
                                color: #666;
                                font-size: 12px;
                                font-weight: 400;
                                width: 80px;
                                flex-shrink: 0;
                            }
                            .par-ul_content {
                                color: rgba(55, 58, 77, 0.9);
                                font-size: 12px;
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
            .tag-info {
                position: absolute;
                top: 6px;
                right: 0;
                padding: 2px 6px;
                border-radius: 0px 6px;
                background: linear-gradient(270deg, #4276ff 0%, #8dabff 100%);
                font-size: 12px;
                color: #fff;
                font-weight: 400;
                display: flex;
                align-content: center;
                align-items: center;
                .tag-info-img {
                    width: 12px;
                    height: 12px;
                    display: inline-block;
                    margin-left: 6px;
                }
            }
        }
    }
    .btm-style {
        border-radius: 8px 8px 0 0;
        background: #fff;
        .tabs {
            ::v-deep {
                .van-sticky {
                    padding: 0 12px;
                    background: #fff;
                }
            }
        }
    }
    .details-content {
        .van-tabs {
            border-radius: 8px 8px 0 0;
            overflow: hidden;
        }
        ::v-deep {
            .van-tabs__nav {
                justify-content: space-between;
            }
            .van-tab {
                font-weight: 400;
                font-size: 14px;
                color: #373a4d;
                padding: 0;
                flex: none;
            }
            .van-tab--active {
                font-weight: 600 !important;
                font-size: 14px !important;
                color: #286df7 !important;
            }
            .van-tabs__line {
                background: #286df7;
            }
        }
    }
}

::v-deep {
    .van-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
        .wrapper-overlay {
            width: 285px;
            border-radius: 10px;
            padding: 16px;
            background: #fff;
            .wrapper-title {
                text-align: center;
                font-size: 16px;
                color: #222;
                margin-bottom: 16px;
            }
            .wrapper-label {
                font-size: 14px;
                color: #555;
                margin-bottom: 4px;
            }
            .c-l-right {
                position: relative;
                display: flex;
                align-items: center;
                .van-cell {
                    padding: 8px;
                }

                .unit {
                    position: absolute;
                    top: 11px;
                    right: 8px;
                    background: #fff;
                }
                .imitation-select {
                    margin-bottom: 17px;
                    width: 100%;
                    position: relative;
                    border-radius: 4px;
                    height: 38px;
                    display: flex;
                    align-items: center;
                    border: 0.5px solid #e5e5e5;
                    padding: 0 8px;
                    .arrow-down {
                        position: absolute;
                        font-size: 15px;
                        right: 7px;
                        top: 11px;
                    }
                }
                .mrsj-button {
                    width: 120px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    padding: 0 22px 0 12px;
                    border-radius: 6px;
                    background: #f7f7fc;
                    color: #999;
                    font-size: 14px;
                }
                .text {
                    flex-shrink: 0;
                }
            }
            .name {
                position: relative;
                .van-cell {
                    height: 38px;
                    padding: 8px 10px;
                }
                .van-field__word-limit {
                    position: absolute;
                    right: 7px;
                    top: 0px;
                }
            }
            .van-cell {
                border: 0.5px solid #e5e5e5;
                border-radius: 4px;
                margin-bottom: 16px;
                &::after {
                    border: none;
                }
            }
            .van-field__control {
                &::placeholder {
                    font-size: 14px;
                }
            }
        }
        .wrapper-btn {
            display: flex;
            align-items: center;
            justify-content: space-between;
            button {
                border: none;
                height: 36px;
                font-size: 14px;
                border-radius: 6px;
                width: 50%;
            }
            .left {
                background: #f5f5f6;
                color: #222;
                margin-right: 12px;
            }
            .rught {
                background: #286df7;
                color: #fff;
                margin-left: 12px;
            }
        }
    }

    .dpfkmbsm {
        padding: 20px 15px 0;
        overflow-y: auto;
        .title {
            font-size: 16px;
            font-weight: 600;
            text-align: center;
        }
        h2 {
            font-size: 13px;
            margin: 5px 0;
        }

        li {
            font-size: 12px;
        }
    }

    .gotit {
        padding: 15px;
        .van-button {
            width: 100% !important;
            height: 36px !important;
            border-radius: 6px !important;
        }
    }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
    .vanEmpty {
        background: #191a24;
    }
    .details-content {
        .name,
        .title {
            color: #e4e9fe !important;
        }
        .title_right {
            .title-right_edit {
                background: rgba(3, 4, 6, 0.37) !important ;
            }
        }
        ::v-deep {
            .van-sticky {
                background: #191a24 !important;
            }
        }
        .yz-list {
            .li {
                border: 1px solid rgba(255, 255, 255, 0.1);
                background: rgba(255, 255, 255, 0.1);
                color: #e4e9fe;
                .par-classify {
                    background: linear-gradient(90deg, #e4e9fe, #e4e9fe);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    color: transparent;
                }
                .par-ul {
                    .par-ul_li {
                        .par-ul_label {
                            color: #aab9d1;
                        }
                        .par-ul_content {
                            color: #e4e9fe;
                        }
                    }
                }
            }
            .li-list {
                border: 1px solid rgba(255, 255, 255, 0.1);
                background: rgba(255, 255, 255, 0.1);
                color: #e4e9fe;
                .par-classify {
                    background: linear-gradient(90deg, #e4e9fe, #e4e9fe);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    color: transparent;
                }
                .sc-list {
                    background: rgba(255, 255, 255, 0.05);
                }
                .tag-title-text {
                    background: linear-gradient(90deg, #e4e9fe, #e4e9fe) !important;
                    -webkit-background-clip: text !important; /* Safari/Chrome */
                    -webkit-text-fill-color: transparentt !important; /* Safari/Chrome */
                    background-clip: textt !important; /* 其他浏览器 */
                    color: transparentt !important;
                }
                .par-ul_label {
                    color: rgba(228, 233, 254, 0.9) !important;
                }
                .par-ul_content {
                    color: #e4e9fe !important;
                }
            }
        }
        ::v-deep {
            .btm-style,
            .van-tabs__nav {
                background: #191a24;
            }
            .van-tab {
                color: #e4e9fe;
            }
        }
    }
    .wrapper-overlay {
        background: #181a23 !important;
        .unit {
            background: #181a23 !important;
            color: #e4e9fe !important;
        }
        .wrapper-title {
            color: #e4e9fe !important;
        }
        .wrapper-label {
            color: #aab9d1 !important;
        }
        .van-cell,
        .imitation-select {
            background: none;
            border: 1px solid #3b3d43 !important;
            color: #e4e9fe !important;
        }
        ::v-deep {
            .van-field__control {
                color: #e4e9fe !important;
            }
        }
        .wrapper-btn {
            .left {
                background: #46484f;
                color: #aab9d1;
            }
        }
    }

    .dpfkmbsm {
        background: #1b2135;
        .title,
        h2 {
            color: #e4e9fe;
        }
        li {
            color: #aab9d1;
        }
    }

    .gotit {
        background: #1b2135;
    }
}
</style>
